import comp from '../components/barrel';
import {mountLeadForm, applyLeadTypeVisibility, collectLeadForm, validateLeadForm, markLeadFormClean, SOURCE_OF_LEAD_OTHER} from '../js/leadForm';

const EP = 'advisors/upd-lead';

export default {
  async prepare() {},

  async render() {
    await this.loadPage();
  },

  async loadPage() {
    const form = U.id('leadDetailsForm');
    if (!form) return;
    const page = thsPage || {};
    if (page.leadDetailsError) {
      form.textContent = page.leadDetailsError;
      return;
    }
    const lead = page.leadDetails;
    if (!lead) {
      form.textContent = 'No lead selected.';
      return;
    }
    await mountLeadForm(form, {
      isMarketer: !!page.isMarketer,
      marketers: page.marketersData || [],
      lead,
      showActive: true,
      showAttribution: true,
      onTypeChange: 'thsTab.onLeadTypeChange()',
    });
  },

  onLeadTypeChange() {
    applyLeadTypeVisibility();
  },

  async saveLead() {
    const page = thsPage || {};
    const lead = page.leadDetails;
    if (!lead || !lead.lead_uuid) return;
    const payload = collectLeadForm();
    payload.lead_uuid = lead.lead_uuid;
    if (page.isMarketer) payload.marketer_uuid = lead.marketer_uuid;
    else if (!payload.marketer_uuid) {
      comp.toast('Choose a marketer');
      return;
    }
    const error = validateLeadForm(payload);
    if (error) {
      comp.toast(error);
      return;
    }
    if (page.isMarketer) {
      payload.marketersource = page.loggedInUuid || null;
    } else {
      const chosen = payload.source_of_lead;
      payload.marketersource = !chosen || chosen === SOURCE_OF_LEAD_OTHER ? null : chosen;
    }
    delete payload.source_of_lead;
    try {
      const res = await O.PREP([await O.mPOST(EP, payload)]);
      const result = res[EP] || {};
      if (result.status === 'OK') {
        page.leadDetails = result.data;
        markLeadFormClean();
        comp.toast('Lead updated');
        return;
      }
      comp.toast((result.data && result.data.error) || 'Unable to update lead');
    } catch (e) {
      comp.toast('Unable to update lead');
    }
  },
};
